import { ReactNode } from 'react';

export interface MatrixStrip {
  /** the split label inside a cell, e.g. "Vmin · 9 V" */
  split: string;
  value: ReactNode;
  note?: ReactNode;
  state: 'pass' | 'fail' | 'none';
}

interface CoverageMatrixProps {
  title?: ReactNode;
  rowLabel?: string;
  rows: string[];
  cols: string[];
  /** strips for one row × col; an empty array renders a dashed empty cell */
  cell: (row: string, col: string) => MatrixStrip[];
}

/** Every planned combination on the page, evidenced or not — one strip per split (supply corner) inside each cell. */
export function CoverageMatrix({ title, rowLabel = 'Signal', rows, cols, cell }: CoverageMatrixProps) {
  return (
    <div className="table-scroll">
      <table className="matrix">
        {title && <caption>{title}</caption>}
        <thead>
          <tr>
            <th scope="col">{rowLabel}</th>
            {cols.map((c) => <th key={c} scope="col">{c}</th>)}
          </tr>
        </thead>
        <tbody>
          {rows.length === 0 && (
            <tr><td className="table-empty" colSpan={cols.length + 1}>No planned combinations</td></tr>
          )}
          {rows.map((r) => (
            <tr key={r}>
              <th scope="row">{r}</th>
              {cols.map((c) => {
                const strips = cell(r, c);
                return (
                  <td key={c} className="mx">
                    {strips.length === 0 && <div className="mx-strip none"><span className="mx-split">—</span><span className="mx-value">n/a</span></div>}
                    {strips.map((s) => (
                      <div key={s.split} className={`mx-strip ${s.state}`}>
                        <span className="mx-split">{s.split}</span>
                        <span className="mx-value">{s.value}</span>
                        {s.note && <span className="mx-note">{s.note}</span>}
                      </div>
                    ))}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
